import { useState, useCallback } from "react";

export type ToastSeverity = "success" | "error" | "warning" | "info";

export interface ToastState {
  open: boolean;
  message: string;
  severity: ToastSeverity;
}

export const useToast = () => {
  const [toast, setToast] = useState<ToastState>({
    open: false,
    message: "",
    severity: "info",
  });

  const showToast = useCallback(
    (message: string, severity: ToastSeverity = "info") => {
      setToast({
        open: true,
        message,
        severity,
      });
    },
    []
  );

  const showError = useCallback((message: string) => {
    setToast({
      open: true,
      message,
      severity: "error",
    });
  }, []);

  const showSuccess = useCallback((message: string) => {
    setToast({
      open: true,
      message,
      severity: "success",
    });
  }, []);

  const showWarning = useCallback((message: string) => {
    setToast({
      open: true,
      message,
      severity: "warning",
    });
  }, []);

  const showInfo = useCallback((message: string) => {
    setToast({
      open: true,
      message,
      severity: "info",
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);

  return {
    toast,
    showToast,
    showError,
    showSuccess,
    showWarning,
    showInfo,
    hideToast,
  };
};
